module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', [(_vm.isLoading) ? _c('CustomLoader', {
    attrs: {
      "width": 70
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('h5', {
    staticClass: "mt-4"
  }, [_c('b-badge', {
    attrs: {
      "variant": "info"
    }
  }, [_vm._v("Container Details : " + _vm._s(_vm.allContainersDataArray.length) + " Container\n    ")])], 1), _vm._v(" "), _c('table', {
    staticClass: "table table-sm mt-2 shadow p-3 mb-5 bg-white rounded"
  }, [_c('tbody', [(_vm.TYPE == 'IMPORT') ? _c('tr', [_c('th', {
    staticStyle: {
      "width": "20px"
    },
    attrs: {
      "bgcolor": "whiteSmoke"
    }
  }, [_c('b-form-checkbox', {
    staticClass: "align-center",
    staticStyle: {
      "height": "2px !important"
    },
    attrs: {
      "disabled": _vm.viewPagePref == 1,
      "size": "lg",
      "value": "1",
      "unchecked-value": "0"
    },
    model: {
      value: (_vm.checkAll),
      callback: function($$v) {
        _vm.checkAll = $$v
      },
      expression: "checkAll"
    }
  })], 1), _vm._v(" "), _c('th', {
    attrs: {
      "bgcolor": "whiteSmoke"
    }
  }, [_vm._v("Container Type & No.")]), _vm._v(" "), (_vm.JOB == 'CC') ? _c('th', [_vm._v("Shipping Bills")]) : _vm._e(), _vm._v(" "), (_vm.JOB == 'CC') ? _c('th', [_vm._v("Shipper Invoices")]) : _vm._e(), _vm._v(" "), _c('th', [_vm._v("Rail Out Date")]), _vm._v(" "), _c('th', [_vm._v("ICD Arrival Date")]), _vm._v(" "), _c('th', [_vm._v("Free Days Upto")])]) : _c('tr', [_c('th', {
    staticStyle: {
      "width": "20px"
    },
    attrs: {
      "bgcolor": "whiteSmoke"
    }
  }, [_c('b-form-checkbox', {
    staticClass: "align-center",
    staticStyle: {
      "height": "2px !important"
    },
    attrs: {
      "disabled": _vm.viewPagePref == 1,
      "size": "lg",
      "value": "1",
      "unchecked-value": "0"
    },
    model: {
      value: (_vm.checkAll),
      callback: function($$v) {
        _vm.checkAll = $$v
      },
      expression: "checkAll"
    }
  })], 1), _vm._v(" "), _c('th', {
    attrs: {
      "bgcolor": "whiteSmoke"
    }
  }, [_vm._v("Container Type & No.")]), _vm._v(" "), _c('th', [_vm._v("Wgt. & Measurement")]), _vm._v(" "), _c('th', [_vm._v("Custom & Line Seal No.")]), _vm._v(" "), _c('th', [_vm._v("Shipping Bills")]), _vm._v(" "), _c('th', [_vm._v("Shipper Invoices")]), _vm._v(" "), _c('th', [_vm._v("Other")])]), _vm._v(" "), _vm._l((_vm.allContainersDataArray), function(item, index) {
    return _c('tr', {
      key: index
    }, [_c('td', {
      staticStyle: {
        "text-align": "center",
        "vertical-align": "middle",
        "width": "20px"
      },
      attrs: {
        "bgcolor": "whiteSmoke"
      }
    }, [_c('b-form-checkbox', {
      attrs: {
        "disabled": _vm.viewPagePref == 1,
        "size": "lg",
        "value": item.uniqueContainerId
      },
      model: {
        value: (_vm.singleSelectContainer),
        callback: function($$v) {
          _vm.singleSelectContainer = $$v
        },
        expression: "singleSelectContainer"
      }
    })], 1), _vm._v(" "), _c('td', {
      staticStyle: {
        "text-align": "left",
        "vertical-align": "middle",
        "width": "200px"
      },
      attrs: {
        "bgcolor": "whiteSmoke"
      }
    }, [(item.sub_noti_event_code == 4) ? _c('span', {
      class: {
        alert: true,
          'alert-danger-text': item.sub_noti_event_code == 4,
          blink: item.sub_noti_event_code == 4,
      }
    }, [_vm._v("This Container has been Rolled Over"), _c('br')]) : _vm._e(), _vm._v(" "), _c('b-button', {
      attrs: {
        "disabled": _vm.viewPagePref == 1,
        "size": "sm",
        "variant": "outline-info"
      },
      on: {
        "click": function($event) {
          _vm.showModal(item.uniqueContainerId, index)
        }
      }
    }, [_vm._v(_vm._s(item.containerType) + " "), _c('i', {
      staticClass: "fa fa-edit"
    })]), (item.containerNo) ? _c('b', {
      staticClass: "ml-2"
    }, [_c('br'), _c('br'), _vm._v(_vm._s(item.containerNo))]) : _vm._e(), _vm._v(" "), (item.sub_noti_event_message) ? _c('b', {
      staticClass: "ml-2 text-danger"
    }, [_c('br'), _vm._v("Event MSG : " + _vm._s(item.sub_noti_event_message))]) : _vm._e()], 1), _vm._v(" "), (_vm.TYPE != 'IMPORT') ? _c('td', [_vm._v("\n          Net Wgt. : " + _vm._s(item.netWeight)), _c('br'), _vm._v("Gross Wgt. : " + _vm._s(item.grossWeight)), _c('br'), _vm._v("Tare Wgt. : " + _vm._s(item.tareWeight)), _c('br'), _vm._v("Unit :" + _vm._s(item.weightUnit)), _c('br'), _vm._v("Measurement :\n          " + _vm._s(item.measurement) + "\n        ")]) : _vm._e(), _vm._v(" "), (_vm.TYPE != 'IMPORT') ? _c('td', [_vm._v("\n          Custom Seal : " + _vm._s(item.customSealNo)), _c('br'), _vm._v("\n          Line Seal : " + _vm._s(item.LineSealNo) + "\n        ")]) : _vm._e(), _vm._v(" "), (_vm.TYPE != 'IMPORT') ? _c('td', [_vm._v("\n          SB No. : " + _vm._s(item.shippingBillNo)), _c('br'), _vm._v("\n          SB Date :\n          " + _vm._s(item.shippingBillDate ? item.shippingBillDate.split(" ")[0] : "") + "\n        ")]) : _vm._e(), _vm._v(" "), (_vm.TYPE != 'IMPORT') ? _c('td', [_vm._v("\n          Shipper Inv No. : " + _vm._s(item.shipperInvoiceNo)), _c('br'), _vm._v("\n          Date :\n          " + _vm._s(item.shipperInvoiceDate ? item.shipperInvoiceDate.split(" ")[0] : "") + "\n        ")]) : _vm._e(), _vm._v(" "), (_vm.TYPE != 'IMPORT') ? _c('td', [_vm._v("\n          Package : " + _vm._s(item.packageName)), _c('br'), _vm._v("\n          No.of Package : " + _vm._s(item.noOfpkgUnit) + "\n\n          "), (_vm.JOB == 'CC') ? _c('span', [_c('br'), _vm._v("Booking No. : " + _vm._s(item.containerBookingNo) + "\n          ")]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.TYPE == 'IMPORT' && _vm.JOB == 'CC') ? _c('td', [_vm._v("\n          SB No. : " + _vm._s(item.shippingBillNo)), _c('br'), _vm._v("\n          SB Date :\n          " + _vm._s(item.shippingBillDate ? item.shippingBillDate.split(" ")[0] : "") + "\n        ")]) : _vm._e(), _vm._v(" "), (_vm.TYPE == 'IMPORT' && _vm.JOB == 'CC') ? _c('td', [_vm._v("\n          Shipper Inv No. : " + _vm._s(item.shipperInvoiceNo)), _c('br'), _vm._v("\n          Date :\n          " + _vm._s(item.shipperInvoiceDate ? item.shipperInvoiceDate.split(" ")[0] : "") + "\n        ")]) : _vm._e(), _vm._v(" "), (_vm.TYPE == 'IMPORT') ? _c('td', [_vm._v(_vm._s(item.importPortETAorRailOutDt))]) : _vm._e(), _vm._v(" "), (_vm.TYPE == 'IMPORT') ? _c('td', [_vm._v(_vm._s(item.importCFSorArrivalDt))]) : _vm._e(), _vm._v(" "), (_vm.TYPE == 'IMPORT') ? _c('td', [_vm._v(_vm._s(item.importFreeDaysUpto))]) : _vm._e()])
  })], 2)]), _vm._v(" "), _c('div', [_c('b-modal', {
    ref: "my-modal-con",
    attrs: {
      "size": "xl",
      "hide-footer": "",
      "no-close-on-esc": "",
      "no-close-on-backdrop": "",
      "title": ""
    }
  }, [_c('div', {
    staticClass: "d-block text-left"
  }, [_c('h6', {
    staticStyle: {
      "color": "green"
    }
  }, [_c('u', [_vm._v("CONTAINER DETAILS")])]), _vm._v(" "), _c('span', {
    staticClass: "error"
  }, [_vm._v("* Marked Field are mandatory..!!")])]), _vm._v(" "), _c('div', {
    staticClass: "gutr"
  }, [_c('b-card', {
    staticStyle: {
      "background": "whiteSmoke"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-gutter": ""
    }
  }, [(_vm.containerNoRegexError != '') ? _c('span', [_c('b', [_vm._v(_vm._s(_vm.containerNoRegexError))])]) : _vm._e(), _vm._v(" "), (_vm.conAlreadyExists != '') ? _c('h5', {
    staticClass: "ml-2 mr-2 error"
  }, [_c('b', [_vm._v(_vm._s(_vm.conAlreadyExists))])]) : _vm._e(), _vm._v(" "), (
    _vm.containerNoRegexError == '' &&
    _vm.containerModal.containerNo != '' &&
    _vm.containerModal.containerNo != _vm.algoConNo &&
    _vm.showAlgo == true
  ) ? _c('span', [_c('b', [_vm._v("Note : System Generated Container No. is : " + _vm._s(_vm.algoConNo))])]) : _vm._e()]), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "45"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', [_vm._v("Container No*. (eg. AAAA1234567)")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "disabled": _vm.assignmentJobType.includes('TPT') &&
        _vm.containerModal.containerInfo == 'fcl' &&
        _vm.assignmentType == 'Export' ?
        true :
        _vm.containerModal.containerNoUpdateCounter >= 3 ?
        true :
        _vm.assignmentJobType == 'FF' &&
        _vm.assignmentType == 'Export' &&
        _vm.containerModal.containerInfo == 'lcl' &&
        !_vm.containerModal.EnabledContainerFeild ?
        false :
        _vm.containerModal.jobType.includes('TPT') &&
        _vm.containerModal.containerInfo == 'fcl' &&
        _vm.assignmentType == 'Export' &&
        _vm.containerModal.containerNoUpdateCounter >= 3 ?
        true :
        _vm.JOB == 'FF' ?
        _vm.containerModal.containerInfo == 'lcl' &&
        _vm.containerModal.transportType == 'Export' ?
        !_vm.containerModal.containerNo ?
        true :
        _vm.containerModal.EnabledContainerFeild :
        false :
        _vm.containerModal.containerNoUpdateCounter == 1 &&
        _vm.containerModal.containerNo ?
        true :
        _vm.disableContainer,
      "maxlength": "11",
      "name": "containerNo"
    },
    on: {
      "keyup": function($event) {
        _vm.containerNoRegexfun();
        _vm.CheckContainerNumber();
      },
      "input": function($event) {
        _vm.CheckContainerNumber()
      }
    },
    model: {
      value: (_vm.containerModal.containerNo),
      callback: function($$v) {
        _vm.$set(_vm.containerModal, "containerNo", $$v)
      },
      expression: "containerModal.containerNo"
    }
  }), _vm._v(" "), _c('b', {
    class: _vm.checkContNoButton == 1 ? 'success' : 'error'
  }, [_vm._v("\n                  " + _vm._s(_vm.timmerMsg) + "\n                ")])], 1)], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "30"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', {
    attrs: {
      "for": "containerType"
    }
  }, [_vm._v("Container Type/Size*")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "disabled": ""
    },
    model: {
      value: (_vm.containerModal.containerType),
      callback: function($$v) {
        _vm.$set(_vm.containerModal, "containerType", $$v)
      },
      expression: "containerModal.containerType"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('b-form-checkbox', {
    staticClass: "align-center",
    staticStyle: {
      "height": "2px !important"
    },
    attrs: {
      "size": "lg",
      "value": "1",
      "unchecked-value": "0"
    },
    on: {
      "change": _vm.selectAllContainers
    },
    model: {
      value: (_vm.checkAll),
      callback: function($$v) {
        _vm.checkAll = $$v
      },
      expression: "checkAll"
    }
  }), _vm._v(" "), _c('h6', {
    staticClass: "mt-2"
  }, [_vm._v("\n            Below Details Same For Selected\n            " + _vm._s(_vm.singleSelectContainer.length > 0 ? _vm.singleSelectContainer.length : "") + "\n            Containers\n          ")]), _vm._v(" "), (_vm.TYPE == 'IMPORT') ? _c('div', [_c('md-layout', {
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "20"
    }
  }, [_c('label', [_vm._v("Port ETA / Rail Out Date")]), _vm._v(" "), _c('date-picker', {
    attrs: {
      "format": _vm.selectDateFormat,
      "lang": "en",
      "id": "importPortETAorRailOutDt",
      "name": "importPortETAorRailOutDt"
    },
    model: {
      value: (_vm.containerModal.importPortETAorRailOutDt),
      callback: function($$v) {
        _vm.$set(_vm.containerModal, "importPortETAorRailOutDt", $$v)
      },
      expression: "containerModal.importPortETAorRailOutDt"
    }
  })], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "20"
    }
  }, [_c('label', [_vm._v("CFS Arrival / ICD Arrival Date")]), _vm._v(" "), _c('date-picker', {
    attrs: {
      "format": _vm.selectDateFormat,
      "lang": "en",
      "id": "importCFSorArrivalDt",
      "name": "importCFSorArrivalDt"
    },
    model: {
      value: (_vm.containerModal.importCFSorArrivalDt),
      callback: function($$v) {
        _vm.$set(_vm.containerModal, "importCFSorArrivalDt", $$v)
      },
      expression: "containerModal.importCFSorArrivalDt"
    }
  })], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "15"
    }
  }, [_c('label', [_vm._v("Free Days Upto")]), _vm._v(" "), _c('date-picker', {
    attrs: {
      "format": _vm.selectDateFormat,
      "lang": "en",
      "id": "importFreeDaysUpto",
      "name": "importFreeDaysUpto"
    },
    model: {
      value: (_vm.containerModal.importFreeDaysUpto),
      callback: function($$v) {
        _vm.$set(_vm.containerModal, "importFreeDaysUpto", $$v)
      },
      expression: "containerModal.importFreeDaysUpto"
    }
  })], 1)], 1)], 1) : _c('div', [_c('md-layout', {
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "20"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', [_vm._v("Line Seal No")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "id": "LineSealNo",
      "name": "LineSealNo"
    },
    model: {
      value: (_vm.containerModal.LineSealNo),
      callback: function($$v) {
        _vm.$set(_vm.containerModal, "LineSealNo", $$v)
      },
      expression: "containerModal.LineSealNo"
    }
  })], 1)], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "20"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', [_vm._v("Custom Seal No")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "id": "customSealNo",
      "name": "customSealNo"
    },
    model: {
      value: (_vm.containerModal.customSealNo),
      callback: function($$v) {
        _vm.$set(_vm.containerModal, "customSealNo", $$v)
      },
      expression: "containerModal.customSealNo"
    }
  })], 1)], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "30"
    }
  }, [_c('label', [_vm._v("Package Details")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.packageNameList,
      "id": "clientId",
      "option-value": "packageId",
      "option-text": "packageName",
      "placeholder": "Select  Package Name"
    },
    model: {
      value: (_vm.containerModal.packageId),
      callback: function($$v) {
        _vm.$set(_vm.containerModal, "packageId", $$v)
      },
      expression: "containerModal.packageId"
    }
  })], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "15"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', [_vm._v("No. of Packages ")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "name": "noOfpkgUnit",
      "id": "noOfpkgUnit",
      "type": "number",
      "min": "0",
      "disabled": _vm.containerModal.packageName == '' ? true : false
    },
    model: {
      value: (_vm.containerModal.noOfpkgUnit),
      callback: function($$v) {
        _vm.$set(_vm.containerModal, "noOfpkgUnit", $$v)
      },
      expression: "containerModal.noOfpkgUnit"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('md-layout', {
    staticClass: "gutr",
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "15"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', [_vm._v("Container Tare Wgt.")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "id": "tareWeight",
      "name": "tareWeight",
      "type": "number",
      "min": "0"
    },
    model: {
      value: (_vm.containerModal.tareWeight),
      callback: function($$v) {
        _vm.$set(_vm.containerModal, "tareWeight", $$v)
      },
      expression: "containerModal.tareWeight"
    }
  })], 1)], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "10"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', [_vm._v("Net Wgt.")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "id": "netWeight",
      "name": "netWeight",
      "type": "number",
      "min": "0"
    },
    model: {
      value: (_vm.containerModal.netWeight),
      callback: function($$v) {
        _vm.$set(_vm.containerModal, "netWeight", $$v)
      },
      expression: "containerModal.netWeight"
    }
  })], 1)], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "10"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', [_vm._v("Gross Wgt.*")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "id": "grossWeight",
      "name": "grossWeight",
      "type": "number",
      "min": "0"
    },
    model: {
      value: (_vm.containerModal.grossWeight),
      callback: function($$v) {
        _vm.$set(_vm.containerModal, "grossWeight", $$v)
      },
      expression: "containerModal.grossWeight"
    }
  })], 1)], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "10"
    }
  }, [_c('label', {
    attrs: {
      "for": "weightUnit"
    }
  }, [_vm._v("Unit*")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.unitList,
      "option-value": "uV",
      "option-text": "uT",
      "placeholder": "Select",
      "name": "weightUnit",
      "id": "weightUnit"
    },
    model: {
      value: (_vm.containerModal.weightUnit),
      callback: function($$v) {
        _vm.$set(_vm.containerModal, "weightUnit", $$v)
      },
      expression: "containerModal.weightUnit"
    }
  })], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "35"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', [_vm._v("Measurement (in CBM)")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "name": "noOfpkgUnit",
      "id": "noOfpkgUnit",
      "type": "number",
      "min": "0"
    },
    model: {
      value: (_vm.containerModal.measurement),
      callback: function($$v) {
        _vm.$set(_vm.containerModal, "measurement", $$v)
      },
      expression: "containerModal.measurement"
    }
  })], 1)], 1)], 1), _vm._v(" "), (_vm.JOB == 'FF') ? _c('md-layout', {
    staticClass: "gutr",
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "30"
    }
  }, [_c('label', [_vm._v("Pickup Location")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.pickUpList,
      "option-value": "pickupId",
      "option-text": "pickupLocation",
      "placeholder": "Search PickUp Location",
      "name": "PickupLocation",
      "id": "PickupLocation"
    },
    on: {
      "input": function($event) {
        _vm.getLocationList($event, 'All', 'pickUpListpickUpList')
      },
      "searchchange": function($event) {
        _vm.getLocationList($event, 'All', 'pickUpList')
      }
    },
    model: {
      value: (_vm.containerModal.PickupLocation),
      callback: function($$v) {
        _vm.$set(_vm.containerModal, "PickupLocation", $$v)
      },
      expression: "containerModal.PickupLocation"
    }
  })], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "25"
    }
  }, [_c('label', [_vm._v("Handover Location")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.handoverList,
      "option-value": "pickupId",
      "option-text": "pickupLocation",
      "placeholder": "Select Handover Location",
      "name": "StuffingLocation",
      "id": "StuffingLocation"
    },
    on: {
      "input": function($event) {
        _vm.getLocationList($event, 'All', 'handoverList')
      },
      "searchchange": function($event) {
        _vm.getLocationList($event, 'All', 'handoverList')
      }
    },
    model: {
      value: (_vm.containerModal.StuffingLocation),
      callback: function($$v) {
        _vm.$set(_vm.containerModal, "StuffingLocation", $$v)
      },
      expression: "containerModal.StuffingLocation"
    }
  })], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "15"
    }
  }, [_c('label', [_vm._v("Pickup Date")]), _vm._v(" "), _c('date-picker', {
    attrs: {
      "format": _vm.selectDateFormat,
      "lang": "en",
      "id": "pickupDate",
      "minute-step": 1,
      "name": "pickupDate"
    },
    model: {
      value: (_vm.containerModal.pickupDate),
      callback: function($$v) {
        _vm.$set(_vm.containerModal, "pickupDate", $$v)
      },
      expression: "containerModal.pickupDate"
    }
  })], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "15"
    }
  }, [_c('label', [_vm._v("Stuffing Date")]), _vm._v(" "), _c('date-picker', {
    attrs: {
      "format": _vm.selectDateFormat,
      "lang": "en",
      "id": "stuffingDate",
      "minute-step": 1,
      "name": "stuffingDate"
    },
    model: {
      value: (_vm.containerModal.stuffingDate),
      callback: function($$v) {
        _vm.$set(_vm.containerModal, "stuffingDate", $$v)
      },
      expression: "containerModal.stuffingDate"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), _c('md-layout', {
    staticClass: "gutr",
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    staticClass: "gutr",
    attrs: {
      "md-flex": "30"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', [_vm._v("Booking No.")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "id": "containerBookingNo",
      "name": "containerBookingNo"
    },
    model: {
      value: (_vm.containerModal.containerBookingNo),
      callback: function($$v) {
        _vm.$set(_vm.containerModal, "containerBookingNo", $$v)
      },
      expression: "containerModal.containerBookingNo"
    }
  })], 1)], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "20"
    }
  }, [_c('label', [_vm._v("Handover Date.*")]), _vm._v(" "), _c('date-picker', {
    attrs: {
      "format": _vm.selectDateFormat,
      "lang": "en",
      "name": "HandoverDate",
      "id": "HandoverDate",
      "minute-step": 1
    },
    model: {
      value: (_vm.containerModal.handoverDate),
      callback: function($$v) {
        _vm.$set(_vm.containerModal, "handoverDate", $$v)
      },
      expression: "containerModal.handoverDate"
    }
  })], 1)], 1)], 1), _vm._v(" "), (_vm.TYPE != 'IMPORT' || (_vm.JOB == 'CC' && _vm.TYPE == 'IMPORT')) ? _c('div', [_c('hr'), _vm._v(" "), _c('h6', {
    staticClass: "mt-3"
  }, [_c('b-badge', {
    attrs: {
      "variant": "light"
    }
  }, [_vm._v(" Shipper Invoices & Shipping Bill ")])], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "25"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', [_vm._v("Shipper Invoice No.*")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "name": "shipperInvoiceNo",
      "id": "shipperInvoiceNo"
    },
    model: {
      value: (_vm.containerModal.shipperInvoiceNo),
      callback: function($$v) {
        _vm.$set(_vm.containerModal, "shipperInvoiceNo", $$v)
      },
      expression: "containerModal.shipperInvoiceNo"
    }
  })], 1)], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "20"
    }
  }, [_c('label', [_vm._v("Invoice Date.*")]), _vm._v(" "), _c('date-picker', {
    attrs: {
      "format": _vm.selectDateFormat,
      "lang": "en",
      "name": "shippingBillDate",
      "id": "shippingBillDate",
      "minute-step": 1
    },
    model: {
      value: (_vm.containerModal.shipperInvoiceDate),
      callback: function($$v) {
        _vm.$set(_vm.containerModal, "shipperInvoiceDate", $$v)
      },
      expression: "containerModal.shipperInvoiceDate"
    }
  })], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "25"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', [_vm._v("Shipping Bill No.*")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "name": "shippingBillNo",
      "id": "shippingBillNo"
    },
    model: {
      value: (_vm.containerModal.shippingBillNo),
      callback: function($$v) {
        _vm.$set(_vm.containerModal, "shippingBillNo", $$v)
      },
      expression: "containerModal.shippingBillNo"
    }
  })], 1)], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "15"
    }
  }, [_c('label', [_vm._v("Shipping Bill Date*")]), _vm._v(" "), _c('date-picker', {
    attrs: {
      "format": _vm.selectDateFormat,
      "lang": "en",
      "name": "shippingBillDate",
      "id": "shippingBillDate",
      "minute-step": 1
    },
    model: {
      value: (_vm.containerModal.shippingBillDate),
      callback: function($$v) {
        _vm.$set(_vm.containerModal, "shippingBillDate", $$v)
      },
      expression: "containerModal.shippingBillDate"
    }
  })], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.TYPE != 'IMPORT') ? _c('div', [(_vm.JOB == 'FF') ? _c('md-layout', {
    staticClass: "gutr",
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "25"
    }
  }, [_c('label', {
    attrs: {
      "for": "examinationComplete"
    }
  }, [_vm._v("Examination Complete")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.examinationList,
      "option-value": "examValue",
      "option-text": "examText",
      "placeholder": "Select Examination",
      "name": "examinationComplete",
      "id": "examinationComplete"
    },
    model: {
      value: (_vm.containerModal.examinationComplete),
      callback: function($$v) {
        _vm.$set(_vm.containerModal, "examinationComplete", $$v)
      },
      expression: "containerModal.examinationComplete"
    }
  })], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), (_vm.containerModal.examinationComplete == 'Yes') ? _c('md-layout', {
    attrs: {
      "md-flex": "15"
    }
  }, [_c('label', [_vm._v("Examination Date")]), _vm._v(" "), _c('date-picker', {
    attrs: {
      "format": _vm.selectDateFormat,
      "lang": "en",
      "id": "examDate",
      "minute-step": 1,
      "name": "examDate"
    },
    model: {
      value: (_vm.containerModal.examDate),
      callback: function($$v) {
        _vm.$set(_vm.containerModal, "examDate", $$v)
      },
      expression: "containerModal.examDate"
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), (_vm.containerModal.examinationComplete == 'Yes') ? _c('md-layout', {
    attrs: {
      "md-flex": "15"
    }
  }, [_c('label', [_vm._v("LET Export Date")]), _vm._v(" "), _c('date-picker', {
    attrs: {
      "format": _vm.selectDateFormat,
      "lang": "en",
      "id": "LetExport",
      "minute-step": 1,
      "name": "LetExport"
    },
    model: {
      value: (_vm.containerModal.LetExportDate),
      callback: function($$v) {
        _vm.$set(_vm.containerModal, "LetExportDate", $$v)
      },
      expression: "containerModal.LetExportDate"
    }
  })], 1) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.JOB == 'CC') ? _c('md-layout', {
    staticClass: "gutr",
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "25"
    }
  }, [_c('label', [_vm._v("CRN No.")]), _vm._v(" "), _c('b-input', {
    attrs: {
      "name": "Remark",
      "id": "Remark"
    },
    model: {
      value: (_vm.containerModal.crnNo),
      callback: function($$v) {
        _vm.$set(_vm.containerModal, "crnNo", $$v)
      },
      expression: "containerModal.crnNo"
    }
  })], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "15"
    }
  }, [_c('label', [_vm._v("Carting Date")]), _vm._v(" "), _c('date-picker', {
    attrs: {
      "format": _vm.selectDateFormat,
      "lang": "en",
      "id": "bookingDate",
      "name": "bookingDate"
    },
    model: {
      value: (_vm.containerModal.cartingDate),
      callback: function($$v) {
        _vm.$set(_vm.containerModal, "cartingDate", $$v)
      },
      expression: "containerModal.cartingDate"
    }
  })], 1)], 1) : _vm._e()], 1) : _vm._e()], 1)], 1), _vm._v(" "), _c('span', {
    staticClass: "error pull-right"
  }, [_c('b', [_vm._v(_vm._s(_vm.containerModal.UpdateReason))])]), _vm._v(" "), _c('b-button', {
    staticClass: "mt-3 pull-right",
    attrs: {
      "disabled": _vm.isValidContainer ? true : _vm.checkContNoButton != 1 ? true : false,
      "variant": "success"
    },
    on: {
      "click": _vm.submitContainer
    }
  }, [_vm._v("Submit")]), _vm._v(" "), _c('b-button', {
    staticClass: "mt-3",
    attrs: {
      "variant": "outline-danger"
    },
    on: {
      "click": _vm.hideModal
    }
  }, [_vm._v("Cancel & Close")])], 1)], 1), _vm._v(" "), _c('md-dialog-alert', {
    ref: "addPop",
    attrs: {
      "md-content": _vm.alert.content,
      "md-ok-text": _vm.alert.ok
    }
  }), _vm._v(" "), _c('b-modal', {
    ref: "modal-close-conf",
    attrs: {
      "id": "modal-close-conf",
      "title": "Confirmation",
      "centered": "",
      "no-close-on-esc": "",
      "no-close-on-backdrop": "",
      "hide-footer": ""
    }
  }, [_c('h3', [_vm._v("Confirmation")]), _vm._v(" "), (_vm.validate) ? _c('h4', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.containerNoRegexError))]) : _vm._e(), _vm._v(" "), _c('b-button', {
    staticClass: "pull-right",
    attrs: {
      "variant": "danger"
    },
    on: {
      "click": _vm.closeModalConfirm
    }
  }, [_vm._v("\n      Close")])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6c5edcd8","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/component/allModuleForm/containerComponent.vue
// module id = 2720
// module chunks = 0